import {
    FETCH_TIMESHEET_MANAGER_INBOX_REQUEST,
    FETCH_TIMESHEET_MANAGER_INBOX_SUCCESS,
    FETCH_TIMESHEET_MANAGER_INBOX_FAIL,
    FETCH_TIMESHEET_ADMIN_INBOX_REQUEST,
    FETCH_TIMESHEET_ADMIN_INBOX_SUCCESS,
    FETCH_TIMESHEET_ADMIN_INBOX_FAIL,
    TIMESHEET_MANAGER_DECISION_SUCCESS,
    TIMESHEET_ADMIN_DECISION_SUCCESS,
} from "../actions/timesheetWorkflowActions";

const initialState = {
    managerInbox: [],
    adminInbox:   [],
    loading:      false,
    error:        null,
};

const applyDecision = (list, updated) =>
    list.map((t) => (t.id === updated.id ? updated : t));

export default function timesheetWorkflowReducer(state = initialState, action) {
    switch (action.type) {

        case FETCH_TIMESHEET_MANAGER_INBOX_REQUEST:
        case FETCH_TIMESHEET_ADMIN_INBOX_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_TIMESHEET_MANAGER_INBOX_SUCCESS:
            return { ...state, loading: false, managerInbox: action.payload || [] };

        case FETCH_TIMESHEET_ADMIN_INBOX_SUCCESS:
            return { ...state, loading: false, adminInbox: action.payload || [] };

        case FETCH_TIMESHEET_MANAGER_INBOX_FAIL:
        case FETCH_TIMESHEET_ADMIN_INBOX_FAIL:
            return { ...state, loading: false, error: action.payload };

        case TIMESHEET_MANAGER_DECISION_SUCCESS:
            return {
                ...state,
                loading: false,
                managerInbox: applyDecision(state.managerInbox, action.payload),
            };

        case TIMESHEET_ADMIN_DECISION_SUCCESS:
            return {
                ...state,
                loading: false,
                adminInbox: applyDecision(state.adminInbox, action.payload),
            };

        default:
            return state;
    }
}